import type { ConfigPlanner, DocumentoMiolo, Paleta } from '@miolos/core';
import { ladoEfetivo, medirPagina } from '@miolos/core';
import { PaginaImpressa } from './PaginaImpressa';

interface Props {
  documento: DocumentoMiolo;
  paleta: Paleta;
  config: ConfigPlanner;
  resolverImagem?: (url: string) => string;
  /** Marca de cópia não autorizada nas páginas de demonstração. */
  marcaDagua?: string | null;
  marcaDaguaDetalhe?: string | null;
}

/**
 * Documento completo pronto para impressão.
 *
 * Define o tamanho do papel via `@page` e desenha cada página com quebra
 * automática. A orientação e o lado da lombada vêm da configuração: só alterna
 * quando a lombada é espelhada (como num livro).
 */
export function DocumentoImpressao({
  documento,
  paleta,
  config,
  resolverImagem,
  marcaDagua,
  marcaDaguaDetalhe,
}: Props) {
  const formato = documento.paginas[0]?.formato ?? config.formato;
  const medidas = medirPagina(formato, {
    orientacao: config.papel?.orientacao,
    ladoLombada: config.papel?.ladoLombada,
    margemLombadaMm: config.papel?.margemLombadaMm,
    // Com sangria, o papel do arquivo é maior que a folha aparada — e é esse
    // tamanho que o `@page` precisa declarar, senão a impressora corta a sobra.
    sangriaMm: config.sangriaMm ?? 0,
  });

  return (
    <>
      <style>{`@page { size: ${medidas.larguraMm}mm ${medidas.alturaMm}mm; margin: 0; }`}</style>
      {documento.paginas.map((pagina, indice) => (
        <PaginaImpressa
          key={`${pagina.id}-${indice}`}
          pagina={pagina}
          paleta={paleta}
          config={config}
          lado={ladoEfetivo(config.papel, indice % 2 === 1)}
          resolverImagem={resolverImagem}
          marcaDagua={marcaDagua}
          marcaDaguaDetalhe={marcaDaguaDetalhe}
        />
      ))}
    </>
  );
}
